import {useState} from "react";

import "./frontzones.css";

const FrontZones = ({handleZoneClick}) => {

    return (
        <svg
        xmlns='http://www.w3.org/2000/svg'
        x='0'
        y='0'
        enableBackground='new 0 0 445.3 645.6'
        version='1.1'
        viewBox='0 0 445.3 645.6'
        xmlSpace='preserve'
        id='FrontZones'
        >
        <g id="frontNeck">
            <path
            d='M224.1 641c-38.4 0-74.6-7.5-101.9-21-27.7-13.8-42.9-32.3-42.9-52v-.3L99.2 448c.1-.8.7-1.4 1.5-1.6h.4c.6 0 1.3.3 1.6.9 6 8.6 10.6 16.6 14.3 24.3.8 1.7 1.6 3.4 2.3 5.2 2.5 5.6 5 11.3 8.7 16 4.9 6.2 11.5 10.4 17.4 13.7 22.3 12.3 47.3 18.9 72.5 18.9 1.5 0 3 0 4.5-.1H225.1c1.5 0 3 .1 4.5.1 25.2 0 50.3-6.5 72.5-18.9 5.9-3.3 12.6-7.4 17.4-13.7 3.6-4.7 6.2-10.4 8.7-16 .8-1.7 1.5-3.5 2.3-5.2 3.7-7.8 8.3-15.7 14.3-24.3.4-.5 1-.9 1.6-.9h.4c.8.2 1.4.8 1.5 1.6l19.9 119.6v.3c0 19.8-15.2 38.3-42.9 52-26.6 13.6-62.8 21.1-101.2 21.1z'
            className='fzoneColor0'
            ></path>
        </g>
        <g id="frontHead">
            <path
            d='M230 529.2c-1.5 0-3 0-4.5-.1H222.6c-1.5 0-3 .1-4.5.1-25.9 0-51.6-6.7-74.5-19.4-6.2-3.5-13.3-7.9-18.6-14.7-3.9-5.1-6.6-11-9.2-16.8-.8-1.7-1.5-3.4-2.3-5.1-8.2-17.4-20.1-32.6-31.7-47.3-8.6-11-17.6-22.3-25-34.6-5.7-9.4-10.5-19.4-14.4-29.9-8.8-.6-15.5-9.1-18.6-16.5-6.4-15.2-6.1-32.1-5.9-48.3.1-5.6.2-11.4 0-17-.5-14.2-2.8-28.3-7-41.9-.3-.9-.6-1.8-.8-2.7-2.1-6.8-4.3-13.8-3.5-21 1-8.1 7.4-16.8 16.2-16.8h1c4.7.3 8.7 3.2 11.6 5.6.8-8.7 1.6-18.5 2.2-28.1.3-4.8.5-9.8.7-14.6.7-14.4 1.3-29.3 3.7-43.8 2.4-14.2 7.6-35.3 19.3-55 11.1-18.7 25.4-31.8 42.4-39 19.1-8 39.8-10.2 61.1-11.8C187.6 8.8 204.8 8 221 8h6.2c16.1 0 33.4.8 56.1 2.5 21.3 1.6 42 3.7 61.1 11.8 17.1 7.2 31.3 20.3 42.4 39 11.7 19.7 16.9 40.8 19.3 55 2.4 14.5 3.1 29.4 3.7 43.8.2 4.8.4 9.7.7 14.6.6 9.6 1.4 19.4 2.2 28.1 2.9-2.4 6.9-5.2 11.6-5.6h1c8.8 0 15.2 8.7 16.2 16.8.9 7.3-1.3 14.3-3.5 21-.3.9-.6 1.8-.8 2.7-4.1 13.6-6.5 27.7-7 41.9-.2 5.6-.1 11.4 0 17 .3 16.3.5 33.1-5.9 48.3-3.1 7.3-9.8 15.9-18.6 16.5-3.9 10.5-8.8 20.5-14.4 29.9-7.4 12.3-16.3 23.6-25 34.6-11.6 14.7-23.5 29.9-31.7 47.3-.8 1.7-1.5 3.4-2.3 5.1-2.6 5.8-5.2 11.8-9.2 16.8-5.3 6.8-12.4 11.3-18.6 14.7-22.8 12.7-48.6 19.4-74.5 19.4z'
            className='fzoneColor2'
            ></path>
            {/* <path
            d='M227.2 10c18.6 0 37.3 1.1 55.9 2.5 20.5 1.6 41.4 3.6 60.4 11.6 36 15.2 54.4 55.9 60.5 92.5 3.2 19.2 3.3 38.7 4.5 58.2.6 10.7 1.6 21.4 2.6 32.1.9-.8 1.8-1.7 2.8-2.5 3.1-2.6 6.6-4.9 10.6-5.2h.8c7.4 0 13.3 7.6 14.2 15.1.9 7.8-1.9 15.4-4.2 22.9-4.2 13.7-6.6 28-7.1 42.4-.7 21.8 2.7 44.5-5.8 64.6-3.2 7.6-9.9 15.3-17.7 15.3h-.5c-3.9 10.8-8.9 21.2-14.7 30.9-17.3 28.7-42.4 51.5-56.7 82.1-3.5 7.4-6.3 15.2-11.3 21.5-4.8 6.2-11.4 10.5-18 14.2-22.7 12.6-48.1 19.1-73.5 19.1-1.5 0-3 0-4.5-.1h-2.8c-1.5 0-3 .1-4.5.1-25.4 0-50.8-6.5-73.5-19.1-6.7-3.7-13.2-8-18-14.2-4.9-6.3-7.8-14.2-11.3-21.5-14.4-30.7-39.5-53.5-56.8-82.2-5.9-9.7-10.8-20.1-14.7-30.9h-.5c-7.8 0-14.5-7.7-17.7-15.3-8.4-20.1-5-42.9-5.8-64.6-.5-14.4-2.9-28.7-7.1-42.4-2.3-7.5-5.1-15.1-4.2-22.9.9-7.5 6.8-15.1 14.2-15.1h.8c4 .3 7.5 2.7 10.6 5.2 1 .8 1.9 1.6 2.8 2.5 1-10.7 1.9-21.4 2.6-32.1 1.1-19.4 1.3-39 4.5-58.2 6.1-36.6 24.5-77.3 60.5-92.5 19-8 39.9-10.1 60.4-11.6 18.6-1.4 37.3-2.5 55.9-2.5h3.1c1.1.1 2.2.1 3.2.1m0-4H221c-16.2 0-33.5.8-56.2 2.5-21.5 1.6-42.3 3.8-61.7 11.9C85.6 27.8 71 41.2 59.7 60.3c-11.8 20-17.1 41.3-19.5 55.7-2.4 14.6-3.1 29.6-3.8 44-.2 4.8-.4 9.7-.7 14.5-.5 8.3-1.2 16.7-1.9 24.4-2.7-1.9-6-3.5-9.8-3.8h-1.1c-9.9 0-17.1 9.7-18.2 18.6-.9 7.7 1.4 14.9 3.5 21.9.3.9.6 1.8.8 2.7 4.1 13.4 6.4 27.3 6.9 41.4.2 5.6.1 11.3 0 16.9-.3 16.5-.5 33.5 6.1 49.1 3.2 7.5 9.9 16.2 19 17.5 3.9 10.2 8.6 19.9 14.1 29.1 7.5 12.4 16.4 23.8 25.1 34.8 11.5 14.6 23.4 29.7 31.4 46.9.8 1.7 1.5 3.4 2.3 5 2.6 5.9 5.3 12 9.4 17.3 5.5 7.1 12.8 11.7 19.3 15.2 23.1 12.8 49.2 19.6 75.5 19.6 1.5 0 3 0 4.5-.1h2.6c1.5 0 3 .1 4.5.1 26.2 0 52.3-6.8 75.5-19.6 6.4-3.6 13.7-8.2 19.3-15.2 4.1-5.2 6.8-11.4 9.4-17.3.7-1.7 1.5-3.4 2.3-5 8.1-17.2 20-32.3 31.4-46.9 8.7-11 17.6-22.4 25.1-34.8 5.5-9.1 10.3-18.9 14.1-29.1 9.1-1.3 15.8-10 19-17.5 6.6-15.6 6.3-32.7 6.1-49.1-.1-5.6-.2-11.4 0-16.9.5-14 2.8-27.9 6.9-41.4.3-.9.6-1.8.8-2.7 2.2-7 4.4-14.2 3.5-21.9-1.1-8.9-8.3-18.6-18.2-18.6h-1.1c-3.8.3-7.1 1.9-9.8 3.8-.7-7.7-1.4-16.2-1.9-24.4-.3-4.8-.5-9.8-.7-14.5-.7-14.5-1.3-29.4-3.8-44-2.4-14.4-7.7-35.7-19.5-55.7-11.3-19.1-25.9-32.5-43.4-39.9-19.3-8.1-40.2-10.3-61.7-11.9C260.7 6.8 243.4 6 227.2 6z'
            className='fzoneColor1'
            ></path> */}
        </g>
        <path
            d='M331.4 407.5c-15.7-9.4-31.1-23.3-40.7-34.1-23.3-26.2-31-54.8-34-69.9-10.7.8-21.6 1.3-32.8 1.3-11.1 0-22.1-.5-32.8-1.3-2.9 15.1-10.7 43.8-34 69.9-9.6 10.8-24.9 24.7-40.6 34 35.5 13.6 56.6 50.6 59.2 82.7.3 3.4 1 15.1-2.5 29.7 0 0 14.3 7.2 50.7 7.2 36.2 0 50.8-7.2 50.8-7.2-3.5-14.6-2.8-26.3-2.5-29.7 2.8-32 23.8-69 59.2-82.6zM224 417.6c-33.1 0-60-7.5-60-16.7s26.9-16.7 60-16.7 60 7.5 60 16.7-26.8 16.7-60 16.7z'
            className='fzoneColor0 offzone'
        ></path>
        <ellipse
            onClick={handleZoneClick}
            data-zone="Buccale"
            cx='224.1'
            cy='400.9'
            className='fzoneColor2'
            rx='60'
            ry='16.7'
        ></ellipse>
        <path
            onClick={handleZoneClick}
            data-zone="Mentonnière gauche"
            d='M331.6 407.5c14.7 8.8 29.6 13.6 40.2 8-14 18.1-28.9 35.4-38.7 56.4-3.5 7.4-6.3 15.2-11.3 21.5-4.8 6.2-11.4 10.5-18 14.2-9.2 5.1-18.9 9.2-28.8 12.3-3.5-14.6-2.8-26.3-2.5-29.7 2.5-32.2 23.6-69.2 59.1-82.7z'
            className='fzoneColor2'
        ></path>
        <path
            onClick={handleZoneClick}
            data-zone="Mentonnière droit"
            d='M116.8 407.5c-14.7 8.8-29.6 13.6-40.2 8 14 18.1 28.9 35.4 38.7 56.4 3.5 7.4 6.3 15.2 11.3 21.5 4.8 6.2 11.4 10.5 18 14.2 9.2 5.1 18.9 9.2 28.8 12.3 3.5-14.6 2.8-26.3 2.5-29.7-2.5-32.2-23.6-69.2-59.1-82.7z'
            className='fzoneColor2'
        ></path>
        <path
            onClick={handleZoneClick}
            data-zone="Maxillaire gauche"
            d='M353.4 282.2v-.5c-.3 6.3-.5 12.6-.4 19.1.3 31 5.7 84.5 18.6 114.6-21.9 11.5-62.2-21.2-80.7-42.1-23.5-26.4-31.2-55.4-34-70.4 35.8-2.6 68.8-10 96.5-20.7z'
            className='fzoneColor2'
        ></path>
        <path
            onClick={handleZoneClick}
            data-zone="Maxillaire droit"
            d='M94.8 282.2v-.5c.3 6.3.5 12.6.4 19.1-.3 31-5.7 84.5-18.6 114.6 21.9 11.5 62.2-21.2 80.7-42.1 23.5-26.4 31.2-55.4 34-70.4-35.8-2.6-68.8-10-96.5-20.7z'
            className='fzoneColor2'
        ></path>
        <path
            onClick={handleZoneClick}
            data-zone="Temporal gauche"
            d='M371.6 416c-12.9-30.1-18.3-83.6-18.6-114.6-.8-78.7 29.8-139.9 52.5-174.8 1.9 16 2.1 32.2 3.1 48.2.6 10.7 1.6 21.4 2.6 32.1.9-.8 1.8-1.7 2.8-2.5 3.1-2.6 6.6-4.9 10.6-5.2 7.8-.6 14.1 7.3 15 15 .9 7.8-1.9 15.4-4.2 22.9-4.2 13.7-6.6 28-7.1 42.4-.7 21.8 2.7 44.5-5.8 64.6-3.3 7.7-10.1 15.6-18.1 15.3-3.9 10.8-8.9 21.2-14.7 30.9-5.5 9-11.7 17.4-18.1 25.7z'
            className='fzoneColor2'
        ></path>
        <path
            onClick={handleZoneClick}
            data-zone="Temporal droit"
            d='M76.6 416c12.9-30.1 18.3-83.6 18.6-114.6.8-78.7-29.8-139.9-52.5-174.8-1.9 16-2.1 32.2-3.1 48.2-.6 10.7-1.6 21.4-2.6 32.1-.9-.8-1.8-1.7-2.8-2.5-3.1-2.6-6.6-4.9-10.6-5.2-7.8-.6-14.1 7.3-15 15-.9 7.8 1.9 15.4 4.2 22.9 4.2 13.7 6.6 28 7.1 42.4.7 21.8-2.7 44.5 5.8 64.6 3.3 7.7 10.1 15.6 18.1 15.3 3.9 10.8 8.9 21.2 14.7 30.9 5.5 9 11.7 17.4 18.1 25.7z'
            className='fzoneColor2'
        ></path>
        <path
            onClick={handleZoneClick}
            data-zone="Nasale"
            d='M191.4 303.5c10.7.8 21.6 1.3 32.7 1.3s22-.5 32.7-1.3V174.6c-10.7.8-21.6 1.3-32.7 1.3-11.1 0-22-.4-32.7-1.3v128.9z'
            className='fzoneColor2'
        ></path>
        <path
            onClick={handleZoneClick}
            data-zone="Oculaire gauche"
            d='M405.4 126.6c0-.4-.1-.9-.1-1.3-32.8 26-86.3 44.5-148.5 49.3v128.9c35.9-2.8 68.9-10.1 96.6-20.8 3.7-69.7 31.2-124 52-156.1z'
            className='fzoneColor2'
        ></path>
        <path
            onClick={handleZoneClick}
            data-zone="Oculaire droit"
            d='M42.8 125.3c-.1.4-.1.9-.1 1.3 20.8 32.2 48.3 86.5 52 156.1 27.8 10.7 60.8 18 96.6 20.8V174.6c-62.2-4.8-115.7-23.3-148.5-49.3z'
            className='fzoneColor2'
        ></path>
        <path
            onClick={handleZoneClick}
            data-zone="Frontale gauche"
            d='M405.3 125.3c-4.7-39.5-22.9-84.6-61.7-101.2-19-8-39.9-10.1-60.4-11.6-19.6-1.5-39.4-2.6-59-2.5v165.9c75.9 0 142.7-20.2 181.1-50.6z'
            className='fzoneColor2'
        ></path>
        <path
            onClick={handleZoneClick}
            data-zone="Frontale droit"
            d='M165 12.5c-20.5 1.6-41.4 3.6-60.4 11.6-38.8 16.6-57 61.6-61.7 101.2 38.4 30.4 105.2 50.6 181.2 50.6V10c-19.7-.1-39.4 1-59.1 2.5z'
            className='fzoneColor2'
        ></path>
        <g id="frontLines">
            <path
            d='M76.6 416c12.9-30.1 18.3-83.6 18.6-114.6.8-78.7-29.8-139.9-52.5-174.8'
            className='fzoneColor3'
            ></path>
            <path
            d='M371.6 416c-12.9-30.1-18.3-83.6-18.6-114.6-.8-78.7 29.8-139.9 52.5-174.8'
            className='fzoneColor3'
            ></path>
            <path
            d='M42.9 125.3c38.4 30.4 105.2 50.6 181.2 50.6V10'
            className='fzoneColor3'
            ></path>
            <path
            d='M224.1 10v165.9c76 0 142.8-20.2 181.2-50.6'
            className='fzoneColor3'
            ></path>
            <path
            d='M94.7 282.7c27.8 10.7 60.8 18 96.6 20.8'
            className='fzoneColor3'
            ></path>
            <path
            d='M191.4 303.5c10.7.8 21.6 1.3 32.7 1.3s22-.5 32.7-1.3V174.6c-10.7.8-21.6 1.3-32.7 1.3-11.1 0-22-.4-32.7-1.3v128.9z'
            className='fzoneColor3'
            ></path>
            <path
            d='M256.7 303.5c35.9-2.8 68.9-10.1 96.6-20.8'
            className='fzoneColor3'
            ></path>
            <path
            d='M76.6 415.5c21.9 11.5 62.2-21.2 80.7-42.1 23.5-26.4 31.2-55.4 34-70.4'
            className='fzoneColor3'
            ></path>
            <path
            d='M371.6 415.5c-21.9 11.5-62.2-21.2-80.7-42.1-23.5-26.4-31.2-55.4-34-70.4'
            className='fzoneColor3'
            ></path>
            <path
            d='M173.4 519.9c3.5-14.6 2.8-26.3 2.5-29.7-2.6-32.2-23.7-69.2-59.2-82.7'
            className='fzoneColor3'
            ></path>
            <path
            d='M275 519.9c-3.5-14.6-2.8-26.3-2.5-29.7 2.6-32.2 23.7-69.2 59.2-82.7'
            className='fzoneColor3'
            ></path>
            <ellipse
            cx='224.1'
            cy='400.9'
            className='fzoneColor3'
            rx='60'
            ry='16.7'
            ></ellipse>
        </g>
        </svg>
    )
}

export default FrontZones;